import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TenderSelection} from '@frontend/shared-api';
import {TranslocoPipe} from '@jsverse/transloco';
import {Button} from 'primeng/button';
import {MetricTileComponent} from '../../../../../../../../shared/components/metric-tile/metric-tile.component';
import {ModelFieldSelectComponent} from '../../../../../../../../shared/components/inputs/model-field/model-field-select/model-field-select.component';
import {RfpParticipatingTool} from '../../rfp-invitation.types';
import {RfpSelectionChange} from '../rfp-suitability-panel.types';
import {SelectedToolTile} from './rfp-selected-tool-card.types';

const KEY = 'project.steps.rfp.invitationList.matrix.';

@Component({
  selector: 'app-rfp-selected-tool-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppNumberPipe, TranslocoPipe, Button, MetricTileComponent, ModelFieldSelectComponent],
  templateUrl: './rfp-selected-tool-card.component.html',
})
export class RfpSelectedToolCardComponent {
  readonly tool = input.required<RfpParticipatingTool>();
  readonly tools = input.required<RfpParticipatingTool[]>();
  readonly preferred = input(false);
  readonly locked = input(false);

  readonly toolChange = output<string>();
  readonly selectionChange = output<RfpSelectionChange>();

  protected readonly participant = computed(
    () => this.tool().selection === TenderSelection.PARTICIPANT,
  );
  protected readonly participantLabelKey = computed(() =>
    this.participant() ? `${KEY}selectedAsParticipant` : `${KEY}selectAsParticipant`,
  );
  protected readonly participantIcon = computed(() =>
    this.participant() ? 'pi pi-check' : 'pi pi-user-plus',
  );
  protected readonly participantDisabled = computed(() => this.locked() || this.participant());
  protected readonly removeDisabled = computed(() => this.locked() || !this.tool().selection);
  protected readonly assessmentKey = computed(() =>
    this.preferred() ? `${KEY}insidePreferred` : `${KEY}outsidePreferred`,
  );
  protected readonly tiles = computed((): SelectedToolTile[] => {
    const tool = this.tool();
    const suitability = tool.suitability;
    return [
      {labelKey: `${KEY}modeCombined`, value: suitability?.combinedCoverage ?? 0, wide: false},
      {labelKey: `${KEY}functions`, value: suitability?.functionCoverage ?? 0, wide: false},
      {labelKey: `${KEY}rfi`, value: tool.rfiPercentage ?? 0, wide: false},
      {labelKey: `${KEY}countries`, value: suitability?.countryCoverage ?? 0, wide: false},
      {labelKey: `${KEY}dataCompleteness`, value: suitability?.dataCompleteness ?? 0, wide: true},
    ];
  });

  protected selectAsParticipant(): void {
    this.selectionChange.emit({toolId: this.tool().id, selection: TenderSelection.PARTICIPANT});
  }

  protected doNotInvite(): void {
    this.selectionChange.emit({toolId: this.tool().id, selection: null});
  }
}
